import { useParams } from 'react-router-dom';

import { Box, Flex, useTheme } from '@tradener/lumen';

import MonthRange from '~/theme/components/MonthRange';

import useOperationLimitsDetailFilters from '../../hooks/useOperationLimitsDetailFilters';
import CounterpartyHeaderSearch from '../CounterpartyHeaderSearch';

export interface CounterpartyHeaderTopFiltersProps {
  showCounterpartySearch?: boolean;
}

function CounterpartyHeaderTopFilters({ showCounterpartySearch = true }: CounterpartyHeaderTopFiltersProps) {
  const { colors } = useTheme();
  const { counterpartyId } = useParams();
  const { monthRangeValues, monthRangeKey, handleCompetenceRangeChange } = useOperationLimitsDetailFilters();

  return (
    <Flex align="center" columnGap="3" width="fit-content" marginLeft="auto">
      {showCounterpartySearch ? (
        <Box
          width="52"
          minW="52"
          borderRadius="base"
          outline="1px solid"
          outlineOffset="-1px"
          outlineColor={colors.gray[900] + '29'}
          height="8"
        >
          <CounterpartyHeaderSearch currentCounterpartyId={counterpartyId} />
        </Box>
      ) : null}

      <MonthRange
        key={`detail-header-month-range-${monthRangeKey}`}
        id="detail-competence-range"
        onChange={handleCompetenceRangeChange}
        defaultValues={monthRangeValues}
        variant="solid"
        bgColor="transparent"
        borderWidth="1px"
        borderColor={colors.gray[900] + '29'}
        height="8"
        width="56"
        color="gray.900"
      />
    </Flex>
  );
}

export default CounterpartyHeaderTopFilters;
